export default {
  app: 'APP_BCG',
  api: 'https://www.uat.researchfollowapp.com/portal'
};
